import React from 'react';
import ReactMarkdown from 'react-markdown';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

// import Paper from '../Paper';
import Spinner from '../Spinner';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 16px',
    marginBottom: theme.spacing(),
    width: '100%',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
  },
  avatar: {
    height: 80,
    width: 80,
    boxShadow: '0 2px 10px rgba(199, 199, 199, 1)',
    marginTop: -40,
    marginBottom: theme.spacing(),
  },
  stampCardRoot: {
    [theme.breakpoints.up('sm')]: {
      padding: `${theme.spacing()}px ${theme.spacing(2.5)}px 0`,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(),
    },
    marginBottom: theme.spacing(),
  },
  tile: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(),
  },
  noCardText: {
    fontSize: 18,
    fontWeight: 800,
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  cardMedia: {
    height: 220,
    width: 350,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    backgroundSize: 'cover',
  },
  merchantProfile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginTop: theme.spacing(3),
  },
  boxContainer: {
    marginTop: 40,
  },
  markdown: {
    fontFamily: 'ClarikaGeometric',
    fontSize: 16,
    textAlign: 'center',
  },
}));

type Props = {
  merchantName: string;
  merchantCoverImage?: string;
  merchantLogo?: string;
  loading?: boolean;
  joiningDescription?: string;
};

export default function EmptyStampCard({
  merchantName,
  merchantCoverImage,
  merchantLogo,
  loading,
  joiningDescription,
}: Props) {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.root}>
      <div className={classes.cardContainer}>
        <div className={classes.merchantProfile}>
          {!loading && (
            <Typography variant="h5" className={classes.title} gutterBottom>
              {merchantName}
            </Typography>
          )}
        </div>
        <div className={classes.stampCardRoot}>
          {joiningDescription && (
            <ReactMarkdown className={classes.markdown}>
              {joiningDescription}
            </ReactMarkdown>
          )}
          {loading && (
            <Box
              display="flex"
              justifyContent="center"
              className={classes.boxContainer}
            >
              <Spinner />
            </Box>
          )}
        </div>
      </div>
    </Grid>
  );
}
